import React, { useState, useEffect, Fragment } from 'react'
import { Confirm, useTranslate, useNotify, useRefresh } from 'react-admin'
import {
  Collapse,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  TablePagination,
  TableFooter,
  Skeleton,
  Grid,
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  TextField,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Autocomplete,
  CircularProgress,
  Alert,
} from '@mui/material'
import {
  KeyboardArrowUp,
  KeyboardArrowDown,
  Delete,
  Inventory2Outlined,
  Clear,
  Save,
  Visibility,
  Edit,
} from '@mui/icons-material'
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import MoneyOffIcon from '@mui/icons-material/MoneyOff'
import CreditScoreIcon from '@mui/icons-material/CreditScore'
import EditIcon from '@mui/icons-material/Edit'
import { useForm, FormProvider } from 'react-hook-form'
import { ShowCard } from 'src/components/uiElements/cards/ShowCard'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import {
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_EDIT,
  PERMISSION_RECEIPT,
  PERMISSION_REFOUND,
  PERMISSION_CAPTURE,
  PERMISSION_LIST,
  PERMISSION_FRAUD,
  PERMISSION_MOVE_CREDIT,
} from 'src/helper/Permission'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { StatusTableCell } from 'src/components/pages/sales/reservation/helper/StatusTableCell'
import { LoadingButton } from '@mui/lab'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { getAirports } from '../air/AirScaleRow'
import { paymentServices } from 'src/services/payment/Payment.service'
import { customAwait } from '../../helper/customAwait'
import { userServices } from 'src/services/reservation/user/user.service'
import { reverseExchangeRate } from 'src/components/pages/payment/payment/logic/common/calculateReverseExchangeRate'
import { itemServices } from 'src/services/reservation/item/item.service'
import { ModalPayment } from 'src/components/pages/payment/payment/logic/ModalPayment'
import { CONFIRMED, EXPIRED, REJECTED, PENDING, CREATED, FAILED_INVOICED } from '../common/state'
import { getField } from 'src/components/pages/sales/reservation/logic/payment/helper/getField'
import { ItemBalences } from './logic/ItemBalances';
import { ReturnForm } from './logic/ReturnForm';
import { useErrorHandler } from 'src/hooks/useErrorHandler' 
import { ReserveCreditsApplied } from 'src/components/pages/sales/reservation/logic/payment/logic/ReserveCreditsApplied'
import { Search } from '@mui/icons-material'
import RefreshIcon from '@mui/icons-material/Refresh';
import dayjs from 'dayjs'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { ReturnsTable } from './logic/ReturnsTable';
import { parseDateFormat } from 'src/helper/parseDateFormat';
import { CreditsDetail } from './logic/CreditsDetail';
import { EditCreditModal } from './logic/EditCreditModal';
import { BalanceTransfer } from './logic/BalanceTransfer';
const paymentDetailsByType = {
  payment_cash: [
    'cash_name',
    'amount',
    'currency',
    'client_name',
    'client_document_type',
    'client_document_number',
  ],
  payment_bank: ['bank_name', 'coupon_number', 'date_time', 'amount', 'currency'],
  payment_online: [
    'amount',
    'vendor_code',
    'card_number',
    'quota',
    'bank_name',
    'expiry_date',
    'transaction',
    'agency_auth_code',
  ],
  payment_paypal: ['paypal_id', 'status_detail', 'payer.name.surname', 'amount', 'currency', 'date_time'],
  payment_braspag: [
    'card_number',
    'authorization_code',
    'installments',
    'card_holder',
    'card_brand_name',
    'customer_street',
    'customer_number',
    'customer_city',
    'customer_state',
    'customer_country',
    'customer_district',
    'customer_complement',
    'customer_zip_code',
  ],
  payment_pix: [
    'customer_document_type',
    'customer_document_value',
    'customer_name',
    'tx_id',
    'order_id',
    'date_time',
  ],
  payment_retention: [
    'type',
    'date_time',
    'description',
    'number',
  ],
}

const FormWrapper = ({
  defaultValues,
  open,
  handleClose,
  selectedWorkUnit,
  selectedBusinessUnit,
  selectedRecord,
  setLoading,
  getPayments,
}) => {
  const refresh = useRefresh()
  const notify = useNotify()
  const methods = useForm({
    defaultValues: defaultValues,
  })

  const handleSubmit = async (data) => {
    try {
      setLoading(true)
      const response = await reservationServices.editTransactionPayment(data, selectedRecord?.[0]?.id)
      if (response) {
        notify('ra.notification.update_transaction_success', { type: 'success' })
      } else {
        notify('ra.notification.update_transaction_error', { type: 'error' })
      }
    } catch (error) {
      notify('ra.notification.update_transaction_error', { type: 'error' })
    } finally {
      customAwait([refresh, () => setLoading(false)])
      getPayments()
    }
  }

  return (
    <FormProvider {...methods}>
      {open && (
        <ModalPayment
          index={0}
          open={open}
          handleClose={handleClose}
          selectedWorkUnit={selectedWorkUnit}
          selectedBusinessUnit={selectedBusinessUnit}
          record={selectedRecord}
          editableField={true}
          methods={methods}
          onSubmit={handleSubmit}
        />
      )}
    </FormProvider>
  )
}



const MoveCreditReservation = ({
  translate,
  moveCreditReservationForm,
  handleChangeMoveCreditReservation,
}) => {
  const [error, setError] = useState(false)
  const [showedAmount, setShowedAmount] = useState(numberFormatterWithDecimalAndThousand(moveCreditReservationForm?.amount) || 0)

  const handleAmountChange = (e) => {
    let formattedValue = e.target.value
    setShowedAmount(formattedValue)
    /* formattedValue = formattedValue?.replaceAll('.','') */
    formattedValue = formattedValue?.replaceAll(',','.')
    const value = parseFloat(formattedValue) || 0
    if (value > moveCreditReservationForm?.amount_unused) {
      setError(true)
    } else {
      setError(false)
    }
    handleChangeMoveCreditReservation('amount', value)
  }

  const formatCommas = (text) =>{
    return text.replace(',', '.')
  }

  const formatDots = (text) =>{
    return text.replace(/\./g, '')
  }

  return (
    <EditInputsWrap label={translate('ra.field.amount')} md={4} lg={4} style={{ minHeight: 0 }}>
      <TextField
        value={showedAmount}
        onFocus={(e)=>setShowedAmount(formatDots(e.target.value))}
        onBlur={(e)=>setShowedAmount(numberFormatterWithDecimalAndThousand(formatCommas(e.target.value)) || 0)}
        onChange={handleAmountChange}
        size='small'
        type='text'
        sx={{ width: { xs: '100%', sm: '100%' } }}
        error={error}
        helperText={
          error
            ? translate('ra.message.amount_exceeds_unused', {
              amount_credit: moveCreditReservationForm?.amount_unused,
            })
            : ''
        }
      />
    </EditInputsWrap>
  )
}

const ShowUnusedCreditsInfo = ({unusedCreditsExpandInfo, setUnusedCreditsExpandInfo, index}) =>{
  const [isExpanded, setIsExpanded] = useState(false)
  const onExpandInfo = () =>{
    setIsExpanded(!isExpanded)
    const auxiliarExpandInfo = [...unusedCreditsExpandInfo]
    auxiliarExpandInfo[index] = !isExpanded
    setUnusedCreditsExpandInfo(auxiliarExpandInfo)
  }

  return (
    <>
      <IconButton size='small' onClick={onExpandInfo}>
        {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </IconButton>
    </>
  )
}

export const PaymentReservation = ({ reservation, refetch, isFetching }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const showError = useErrorHandler()
  const [dataListCreditUsed, setDataListCreditUsed] = useState([])
  const [dataListCreditUsedLoading, setDataListLoadingCreditUsed] = useState(false)
  const [dataList, setDataList] = useState([])
  const [dataListLoading, setDataListLoading] = useState(false)
  const [loadingReceipt, setLoadingReceipt] = useState(false)
  const [loadingRefund, setLoadingRefund] = useState(false)
  const [loadingCapturePayment, setLoadingCapturePayment] = useState(false)
  const [openRows, setOpenRows] = useState([])
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
  const [modalData, setModalData] = useState({})
  const [paginationData, setPaginationData] = useState({ page: 0, rowsPerPage: 10 })
  /* const paginationItemData = { page: 0, rowsPerPage: 10 } */
  const [paginationCreditData, setPaginationCreditData] = useState({ page: 0, rowsPerPage: 10 })
  const [client, setClient] = useState()
  const [importingReceipt, setImportingReceipt] = useState(false)
  const [generateReceipt, setGenerateReceipt] = useState(false)
  const [loadingGenerateReceipt, setLoadingGenerateReceipt] = useState(false)
  const [selectedTransactions, setSelectedTransactions] = useState([])
  const [openReceiptModal, setOpenReceiptModal] = useState(false)
  const [receiptForm, setReceiptForm] = useState({})
  const [loadingDetail, setLoadingDetail] = useState(false)
  const [openDetailModal, setOpenDetailModal] = useState(false)
  const [detailModalData, setDetailModalData] = useState([])
  const [openCreditModal, setOpenCreditModal] = useState(false)
  const [selectedCreditItemsToCreditData, setSelectedItemsToCreditData] = useState([])
  const [selectedCreditData, setSelectedCreditData] = useState({})
  const [paginationCreditModal, setPaginationCreditModal] = useState({ page: 0, rowsPerPage: 10 })
  const [remainingAmount, setRemainingAmount] = useState(0)
  const [totalAmountToPay, setTotalAmountToPay] = useState(0)
  const [loadingCreditConfirm, setLoadingCreditConfirm] = useState(false)
  const [paymentCurrecies, setPaymentCurrecies] = useState([])
  const [loadingPaymentCurrencies, setLoadingPaymentCurrencies] = useState(false)
  const [openExchangeModal, setOpenExchangeModal] = useState(false)
  const [loadingItemRecalculate, setLoadingItemRecalculate] = useState(false)
  const [isChangeExchange, setIsChangeExchange] = useState(false)
  const [openEditTransactionModal, setOpenEditTransactionModal] = useState(false)
  const [currentIndexSelected, setCurrentIndexSelected] = useState(null)
  const [selectedRecord, setSelectedRecord] = useState({})
  const [defaultValueTransaction, setDefaultValueTransaction] = useState({})
  const [loadingTransactionEdit, setLoadingTransactionEdit] = useState(false)
  const [selectedItems, setSelectedItems] = useState([])
  const [openMoveCreditReservationModal, setOpenMoveCreditReservationModal] = useState(false)
  const [moveCreditReservationForm, setMoveCreditReservationForm] = useState({})
  const [loadingMoveCreditReservation, setLoadingMoveCreditReservation] = useState(false)
  const [loadingReservtions, setLoadingReservtions] = useState(false)
  const [timeoutReservtions, setTimeoutReservtions] = useState()
  const [reservations, setReservtions] = useState([])
  const [searchBy, setSearchBy] = useState('number__ilike')
  const [reservationSelected, setReservationSelected] = useState(null)
  const [reservationHasNotBusiness, setReservationHasNotBusiness] = useState(false)
  const [reservationSelectedHasNotBusiness, setReservationSelectedHasNotBusiness] = useState(false)
  const [reservationHasNotBusinessLoading, setReservationHasNotBusinessLoading] = useState(false)
  const [reservationSelectedHasNotBusinessLoading, setReservationSelectedHasNotBusinessLoading] =
    useState(false)
  const [cancelConfirmation, setCancelConfirmation] = useState(false)
  const [idToCancel, setIdToCancel] = useState(null)
  const [loadingRefresh, setLoadingRefresh] = useState(false)
  const [refreshReserveCreditsApplied, setRefrshReserveCreditsApplied] = useState(false)
  const [unusedCredits, setUnusedCredits] = useState(reservation?.payment_data?.credit_unused)
  const [openReturnDialog, setOpenReturnDialog] = useState(false)
  const [rowToReturn, setRowToReturn] = useState(null)
  const [unusedCreditsLoading, setUnusedCreditsLoading] = useState(false)
  const [unusedCreditsExpandInfo, setUnusedCreditsExpandInfo] = useState([])
  const [openCreditsDetail, setOpenCreditsDetail] = useState(false)
  const [openCreditsEdit, setOpenCreditsEdit] = useState(false)
  const [creditsDetailId, setCreditsDetailId] = useState(0)
  const [creditToEdit, setCreditToEdit] = useState([])
  const [confirmUnapply, setConfirmUnapply] = useState(false)
  const [unapplyLoading, setUnapplyLoading] = useState(false)
  const [amountToUnapply, setAmountToUnapply] = useState(0)
  const [currencyToUnapply, setCurrencyToUanpply] = useState('')
  const [openApplyCreditsModal, setOpenApplyCreditsModal] = useState(false)
  const [applyCreditsLoading, setApplyCreditsLoading] = useState(false)
  const [showedChangeType, setShowedChangeType] = useState(moveCreditReservationForm?.currency_value ? numberFormatterWithDecimalAndThousand(moveCreditReservationForm?.currency_value) : null)

  useEffect(() => {
    if (selectedCreditData && selectedCreditItemsToCreditData) {
      const totalAmountToPayCalculate = selectedCreditItemsToCreditData?.reduce(
        (acc, item) => acc + (parseFloat(item.amount_to_pay) || 0),
        0
      )
      setTotalAmountToPay(totalAmountToPayCalculate)
      const remaining = selectedCreditData?.amount_unused - totalAmountToPayCalculate
      setRemainingAmount(remaining)
    }
  }, [selectedCreditData, selectedCreditItemsToCreditData])


  /* useEffect(() => {
    setUnusedCredits(reservation?.payment_data?.credit_unused)
  }, [isFetching]) */

  useEffect(() => {
    if (reservation.hash_reservation) {
      getExpensesByReservationHash(reservation.hash_reservation)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservation.hash_reservation, refreshReserveCreditsApplied])

  useEffect(() => {
    getUnusedCredits()
    if (reservation.id) {
      getPayments()
      checkClient()
      //checkReservationBusiness()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservation.id])

  const formatPaxItem = (pax_relation) => ({
    pax_id: pax_relation?.id,
    name: pax_relation?.name,
    surname: pax_relation?.surname,
  })

  const addPaxItemInFormatItem = (row) => ({
    pax_relation: row?.pax_relation?.map((pax_relation) => formatPaxItem(pax_relation)),
  })

  const format = (row) => ({
    code: row?.code,
    currency: row?.payment_data?.currency,
    amount_pending: row?.payment_data?.amount_pending,
    product: row?.product,
    passes: row?.passes,
    name: row?.name,
    provider: row?.provider,
    destination: row?.destination,
    pickup_origin: row?.pickup_origin,
    segments: row?.segments,
    item_id: row?.item_id,
    account_detail_relation: row?.payment_data?.account_detail_relation,
    hash_: row?.hash_,
    hash_item: row?.hash_,
    ...addPaxItemInFormatItem(row),
  })

  const formatItems = (item) => {
    try {
      let auxitem = [...item]
      return auxitem?.filter((row) => row?.payment_data?.amount_pending && row?.status !== REJECTED && row?.status !== EXPIRED && row?.status !== FAILED_INVOICED)?.map((row) => format(row))
    } catch (error) {
      return []
    }
  }

  /* const getItemsData = () => {
    console.log("paginationItemData.rowsPerPage", paginationItemData.rowsPerPage)
    return paginationItemData.rowsPerPage > 0
      ? reservation?.items
        ?.filter((item) => item?.status !== REJECTED && item?.status !== EXPIRED)
        ?.slice(
          paginationItemData.page * paginationItemData.rowsPerPage,
          paginationItemData.page * paginationItemData.rowsPerPage + paginationItemData.rowsPerPage
        )
      : reservation?.filter((item) => item?.status !== REJECTED && item?.status !== EXPIRED)?.items
  } */

  /* useEffect(() => {
    setSelectAll(
      formatItems(getItemsData())?.length > 0 && selectedItems.length === formatItems(getItemsData()).length
    )
  }, [selectedItems, formatItems, getItemsData]) */

  const getUnusedCredits = async () =>{
    setUnusedCreditsLoading(true)
    if (reservation.hash_reservation) {
      await paymentServices.getCreditsUnused(reservation.hash_reservation).then((res)=>{
        setUnusedCredits(res)
        setUnusedCreditsExpandInfo(Array(res.length).fill(false))
      }).finally(()=>{
        setUnusedCreditsLoading(false)
      })
    }
  }

  const checkReservationBusiness = async () => {
    try {
      setReservationHasNotBusinessLoading(true)
      const response = await checkExistBusinessInReservationSelected(reservation)
      setReservationHasNotBusiness(!response)
    } catch (error) {
      setReservationHasNotBusiness(true)
    } finally {
      setReservationHasNotBusinessLoading(false)
    }
  }

  const handleCurrencyChange = (index, field, value) => {
    setIsChangeExchange(true)
    const updatedCurrencies = [...paymentCurrecies]
    updatedCurrencies[index] = { ...updatedCurrencies[index], [field]: parseFloat(value) }
    setPaymentCurrecies(updatedCurrencies)
  }

  const getExpensesByReservationHash = async (reservation_hash) => {

    try {
      setDataListLoadingCreditUsed(true)
      const response = await paymentServices.getExpensesByReservationHash(reservation_hash)
      setDataListCreditUsed(response)
    } catch (error) {
      setDataListCreditUsed([])
    } finally {
      setDataListLoadingCreditUsed(false)
    }
  }

  const formatData = (data) => {
    let auxData = [...data]
    return auxData
      .filter((item) => item?.amount_pending)
      .map((item) => {
        return {
          amount_to_pay: 0,
          item_id: item.item_id,
          id: item.item_id,
          amount_total_converted: item.amount_total_converted,
          amount_pending_converted: item.amount_pending_converted,
          hash_item: item?.hash_item,
          currency_converted: item.currency_converted,
        }
      })
  }

  const calculateAmountOfItems = async (
    reservation,
    selectedCreditItemsToCreditData,
    paymentCurrecies,
    currency_hash,
    isPaymentItem = false
  ) => {
    try {
      setLoadingItemRecalculate(true)
      const currencies_with_reverse = reverseExchangeRate(paymentCurrecies)
      let items = await itemServices.item_to_pay([reservation?.id], currency_hash, currencies_with_reverse)
      if (items) {
        const item_with_amount_pending_converted = formatData(items)
        const mergedList = (isPaymentItem ? selectedItems : selectedCreditItemsToCreditData).map((item1) => {
          const match = item_with_amount_pending_converted.find((item2) => item2.item_id === item1.item_id)
          if (match) {
            return {
              ...item1,
              amount_total_converted: match.amount_total_converted,
              amount_pending_converted: match.amount_pending_converted,
            }
          }
          return item1
        })
        if (isPaymentItem) {
          // determinar si es el flujo para pagar un item o pagar con credito
          setSelectedItems(mergedList)
        } else {
          setSelectedItemsToCreditData(mergedList)
        }
      }
    } catch (error) {
      console.log('error', error)
      notify('ra.message.reservation_item_not_found', {
        type: 'error',
      })
    } finally {
      setLoadingItemRecalculate(false)
    }
  }

  const getCurrencyByUser = async () => {
    try {
      setLoadingPaymentCurrencies(true)
      const currencies = await userServices.getCurrencyByUser()
      if (currencies) {
        const format = currencies.filter((currency) => !currency?.is_reverse)
        return format
      } else {
        return []
      }
    } catch (error) {
      return []
    } finally {
      setLoadingPaymentCurrencies(false)
    }
  }

  const checkClient = async () => {
    if (reservation.business_unit_id) {
      const clientResponse = await reservationServices
        .checkClient(reservation.business_unit_id)
        .catch((e) => {
          setClient(null)
        })
      if (clientResponse && clientResponse['System response'].Exists === 'true') {
        setClient(clientResponse['B2 DDBB response'].client_info[0])
      }
    }
  }

  const getPayments = () => {
    setLoadingRefresh(true)
    setDataListLoading(true)
    reservationServices
      .getPayments(reservation.id)
      .then((data) => {
        setDataList(data)
        setDataListLoading(false)
      })
      .catch((e) => {
        setDataList([])
        setDataListLoading(false)
      })
      .finally(() => {
        setLoadingRefresh(false)
      })
  }

  const onExpandRow = (id) => {
    let openRowsAux = [...openRows]
    const isExpanded = openRowsAux.find((elem) => elem === id)
    if (!isExpanded) {
      openRowsAux.push(id)
    } else {
      openRowsAux = openRowsAux.filter((elem) => elem !== id)
    }
    setOpenRows(openRowsAux)
  }

  const handleOpenConfirmationModal = (title, callback) => {
    setModalData({ title, callback })
    setOpenConfirmationModal(true)
    setOpenReceiptModal(false)
  }

  const handleReceiptGenerationError = (error, callback) => {
    const body = error?.response?.data
    if (body?.status_code === 418 && error?.response) {
      const detail = body?.data?.errors || body?.data?.data || body?.data
      error.response.status = 418
      error.response.data = {
        ...body,
        data: { errors: Array.isArray(detail) ? detail : [detail] },
      }
    }
    showError(error, callback)
  }

  const handleGenerateReceipt = async (payment) => {
    try {
      if (payment) {
        setLoadingReceipt(payment.payment_entity_id)
        let data = {
          payment_entity_id: [payment.payment_entity_id],
          base_b: false,
        }
        await reservationServices.generateReceiptPayment(data)
        setOpenConfirmationModal(false)
        getPayments()
      }
    } catch (error) {
      handleReceiptGenerationError(error)
    } finally {
      setLoadingReceipt(null)
    }
  }

  const handleGeneratesMultipleReceipt = async (selectedTransactions) => { //todo
    try {
      if (selectedTransactions?.length) {
        setLoadingGenerateReceipt(true)
        let data = {
          payment_entity_id: selectedTransactions,
          base_b: false,
        }
        await reservationServices.generateReceiptPayment(data)
        notify('ra.message.generates_multiple_receipt_success', { type: 'success' })
        setOpenConfirmationModal(false)
        getPayments()
      }
    } catch (error) {
      handleReceiptGenerationError(error, () => notify('ra.message.generates_multiple_receipt_error', { type: 'error' }))
    } finally {
      setSelectedTransactions([])
      setLoadingGenerateReceipt(false)
      setGenerateReceipt(false)
      setOpenConfirmationModal(false)
    }
  }

  const handleCancelReceipt = async (receipt) => {
    if (receipt) {
      const data = [receipt.payment_entity_id]
      await reservationServices.cancelReceiptPayment(data).catch((e) => {
        showError(e)
      })
      setOpenConfirmationModal(false)
      getPayments()
    }
  }

  const handleDeleteTransaction = async (transaction) => {
    if (transaction) {
      setLoadingReceipt(transaction.payment_entity_id)
      await reservationServices.deleteTransactionPayment(transaction.payment_entity_id).catch((e) => {
        showError(e)
      })
      setOpenConfirmationModal(false)
      getPayments()
      setLoadingReceipt(null)
    }
  }

  const handleRefoundTransaction = async (transaction) => {
    try {
      if (transaction) {
        setLoadingRefund(transaction.payment_entity_id)
        const { status } = await reservationServices.refundTransactionPayment(transaction.payment_entity_id)
        if (status >= 200 && status < 205) {
          notify('ra.message.transaction_refund_success', {
            type: 'success',
          })
        } else {
          notify('ra.message.transaction_refund_error', {
            type: 'error',
          })
        }
      }
    } catch (error) {
      notify('ra.message.transaction_refund_error', {
        type: 'error',
      })
    } finally {
      setOpenConfirmationModal(false)
      setLoadingRefund(null)
      getPayments()
    }
  }

  const handleCapturePaymentTransaction = async (transaction) => {
    try {
      if (transaction) {
        setLoadingCapturePayment(transaction.payment_entity_id)
        const { status } = await reservationServices.capturePayment(transaction.payment_entity_id)
        if (status >= 200 && status < 205) {
          notify('ra.message.capture_payment_success', {
            type: 'success',
          })
        } else {
          notify('ra.message.capture_payment_error', {
            type: 'error',
          })
        }
      }
    } catch (error) {
      notify('ra.message.capture_payment_error', {
        type: 'error',
      })
    } finally {
      setOpenConfirmationModal(false)
      setLoadingCapturePayment(null)
      getPayments()
    }
  }

  const onPageChange = (number) => {
    const paginationDataAux = { ...paginationData }
    paginationDataAux.page = number
    setPaginationData(paginationDataAux)
  }

  const onRowsPerPageChange = (e) => {
    const paginationDataAux = { ...paginationData }
    paginationDataAux.rowsPerPage = parseInt(e.target.value, 10)
    paginationDataAux.page = 0
    setPaginationData(paginationDataAux)
  }

  const onPageCreditChange = (number) => {
    const paginationCreditDataAux = { ...paginationCreditData }
    paginationCreditDataAux.page = number
    setPaginationCreditData(paginationCreditDataAux)
  }

  const onRowsPerPageCreditChange = (e) => {
    const paginationCreditDataAux = { ...paginationCreditData }
    paginationCreditDataAux.rowsPerPage = parseInt(e.target.value, 10)
    paginationCreditDataAux.page = 0
    setPaginationCreditData(paginationCreditDataAux)
  }

  const handleOpenReceiptModal = () => {
    setOpenReceiptModal(true)
    setReceiptForm({})
  }

  const handleCancelImportReceipt = () => {
    setImportingReceipt(false)
    setSelectedTransactions([])
  }

  const handleClickImportReceipt = () => {
    if (importingReceipt) {
      handleOpenReceiptModal()
    } else {
      setImportingReceipt(true)
      setSelectedTransactions([])
    }
  }

  const handleSelectTransaction = (item, checked) => {
    let selectedTransactionsAux = [...selectedTransactions]
    if (checked) {
      selectedTransactionsAux.push(item?.payment_entity_relation?.id)
    } else {
      selectedTransactionsAux = selectedTransactionsAux.filter(
        (elem) => elem !== item?.payment_entity_relation?.id
      )
    }
    setSelectedTransactions(selectedTransactionsAux)
  }

  const handleChangeReceiptData = (field, value) => {
    setReceiptForm((current) => ({
      ...current,
      [field]: value,
    }))
  }

  const handleChangeMoveCreditReservation = (field, value) => {
    setMoveCreditReservationForm((current) => ({
      ...current,
      [field]: value,
    }))
  }

  const handleImportReceipt = async () => {
    try {
      setLoadingReceipt(true)
      const data = selectedTransactions.map((payment_entity_id) => ({
        payment_entity_id,
        external_id: receiptForm?.receipt_reference,
      }))
      await reservationServices.importInvoiceReceipt(data)
      setOpenConfirmationModal(false)
      setImportingReceipt(false)
      getPayments()
    } catch (error) {
      setOpenConfirmationModal(false)
      setImportingReceipt(false)
      handleReceiptGenerationError(error)
    } finally {
      setLoadingReceipt(null)
      setSelectedTransactions([])
    }
  }

  const handleCancelGeneratesReceipt = () => {
    setGenerateReceipt(false)
    setSelectedTransactions([])
  }

  const handleClickGeneratesReceipt = () => {
    if (generateReceipt) {
      handleOpenConfirmationModal('generate_receipt_title', () =>
        handleGeneratesMultipleReceipt(selectedTransactions)
      )
    } else {
      setGenerateReceipt(true)
      setSelectedTransactions([])
    }
  }

  const getProductName = (item) => {
    if (item?.product?.ref_table_detail === 'hotel_detail') {
      return item?.name
    } else if (item?.product?.ref_table_detail === 'car_detail') {
      return item?.provider
    } else if (
      item?.product?.ref_table_detail === 'assistance_detail' ||
      item?.product?.ref_table_detail === 'other_detail'
    ) {
      return `${item.destination} / ${item.name}`
    } else if (item?.product?.ref_table_detail === 'transfer_detail') {
      return item?.pickup_origin
    } else if (item?.product?.ref_table_detail === 'air_detail') {
      return getAirports(item?.segments?.[0]?.itineraryGroup)
    } else if (item?.product?.ref_table_detail === 'train_detail_segment') {
      return `${item?.segments?.[0]?.origin_name}/${item?.segments?.[0]?.arrival_name}`
    } else if (item?.product?.ref_table_detail === 'train_detail_passes') {
      return item?.passes?.[0]?.company_name
    }
  }

  const handleShowTransactionDetail = async (payment_entity_id) => {
    try {
      setDetailModalData([])
      if (payment_entity_id) {
        setLoadingDetail(payment_entity_id)
        const response = await reservationServices.getTransactionDetail(payment_entity_id)
        if (response) {
          setDetailModalData(response)
          setOpenDetailModal(true)
        } else {
          setDetailModalData(null)
          setOpenDetailModal(false)
        }
      }
    } catch (error) {
      showError(error)
    } finally {
      setLoadingDetail(null)
    }
  }

  const handleOpenCreditModal = async (row) => {
    const items = reservation.items || []//getItemsData() || []
    const currencies = await getCurrencyByUser()
    const currency_hash = row?.hash_currency
    setPaymentCurrecies(currencies)
    setSelectedCreditData(row)
    calculateAmountOfItems(reservation, formatItems([...items]), currencies, currency_hash)
    setOpenCreditModal(true)
  }

  const handleOpenMoveCreditReservationModal = async (row) => {
    setMoveCreditReservationForm({
      ...row,
      date: dayjs().format('YYYY-MM-DD'),
      amount: row?.amount_unused,
      currency: row?.currency_unused,
    })
    setOpenMoveCreditReservationModal(true)
  }

  const handleCreditAmountChange = (e, rowIndex) => {
    const value = e.target.value
    setSelectedItemsToCreditData((prevState) => {
      const updatedData = [...prevState]
      updatedData[rowIndex] = { ...updatedData[rowIndex], amount_to_pay: parseFloat(value) }
      return updatedData
    })
  }

  const handlePageChangeCreditModal = (event, newPage) => {
    setPaginationCreditModal((prevState) => ({
      ...prevState,
      page: newPage,
    }))
  }

  const handleRowsPerPageChangeCreditModal = (event) => {
    setPaginationCreditModal((prevState) => ({
      ...prevState,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    }))
  }

  const onConfirmCreditModal = async () => {
    try {
      setLoadingCreditConfirm(true)
      let data = {
        paymentType: [], // always like this
        credit: [
          {
            currency: selectedCreditData?.hash_currency,
            ids: selectedCreditData?.ids,
            amount_to_pay: totalAmountToPay,
          },
        ],
        hash_business_unit: reservation?.business_unit_relation?.hash_business_unit,
        amount: totalAmountToPay,
        generate_receipt: false, // always like this
        currency: {
          hash_currency: selectedCreditData?.hash_currency,
        },
        item: selectedCreditItemsToCreditData?.map((item) => {
          const currency = item?.account_detail_relation?.[0].account_relation?.currency_relation
          return {
            amount_to_pay: parseFloat(item?.amount_to_pay) || 0,
            currency: {
              hash_currency: currency?.hash_currency,
              short_name: currency?.short_name,
            },
            hash_item: item?.hash_,
          }
        }),
        currencies_exchange: reverseExchangeRate(paymentCurrecies),
      }
      const response = await paymentServices.liquidateExpenses(data)
      if (response) {
        notify('ra.notification.applied_credit_success', { type: 'success' })
      } else {
        showError(response, () => notify('ra.notification.applied_credit_error', { type: 'error' }))
      }
    } catch (error) {
      showError(error, () => notify('ra.notification.applied_credit_error', { type: 'error' }))
    } finally {
      customAwait([
        refresh,
        () => onCloseCreditModal(),
        () => getExpensesByReservationHash(reservation.hash_reservation),
      ])
      setLoadingCreditConfirm(false)
    }
  }

  const cancelPayment = async () => {
    setUnapplyLoading(true)
    await paymentServices.cancelPayment(idToCancel).then(() => {
      setCancelConfirmation(false)
      getPayments()
      notify('ra.notification.unapply_payment_success', { type: 'success' })
    }).catch(err => {
      notify('ra.notification.unapply_payment_error', { type: 'error' })
    }).finally(()=>{
      setUnapplyLoading(false)
    })
  }

  useEffect(()=>{
    if(confirmUnapply){
      cancelPayment()
    }
  },[confirmUnapply])

  const tranferCreditReservation = async () => {
    try {
      setLoadingMoveCreditReservation(true)
      let data = {
        hash_reservation: reservation.hash_reservation,
        transfer_credit: [
          {
            date: moveCreditReservationForm?.date || new Date(),
            to_number: reservationSelected?.number,
            currency: moveCreditReservationForm?.currency,
            entity_code: moveCreditReservationForm?.entity_code,
            description: moveCreditReservationForm?.description,
            amount: parseFloat(moveCreditReservationForm?.amount) || 0,
            currency_value: moveCreditReservationForm?.currency_value || null
          },
        ],
      }
      const response = await paymentServices.tranferCredit(data)
      if (response) {
        notify('ra.notification.transfer_credit_success', { type: 'success' })
      } else {
        showError(response, () => notify('ra.notification.transfer_credit_error', { type: 'error' }))
      }
    } catch (error) {
      error.response.data.message = (error.response.data.data.errors && Array.isArray(error.response.data.data.errors)) ? error.response.data.data.errors[0] : error.response.data.data
      showError(error, () => notify('ra.notification.transfer_credit_error', { type: 'error' }))
    } finally {
      customAwait([
        refresh,
        () => onCloseMoveCreditReservationModal()
      ])
      setLoadingMoveCreditReservation(false)
    }
  }

  const onOpenEditTransactionModal = async (row, index) => {
    setOpenEditTransactionModal(true)
    setCurrentIndexSelected(index)
    const payment_type =
      row?.payment_entity_relation?.payment_type_by_work_unit_relation?.payment_type_relation
    const payment_detail_relation = row?.payment_entity_relation
    const payment_detail = row?.payment_entity_relation?.payment_detail_relation
    const source = row?.payment_entity_relation?.ref_table_detail
    setDefaultValueTransaction({
      date_time: payment_detail?.date_time,
      [source]: payment_detail,
    })
    const record = [
      {
        ...payment_type,
        id: row?.payment_entity_id,
        name: `la transacción: ${row?.payment_entity_id} - ${payment_detail_relation?.type}`,
        source: source,
      },
    ]
    setSelectedRecord(record)
  }

  const onCloseExhangeModal = () => {
    setOpenExchangeModal(false)
    isChangeExchange &&
      calculateAmountOfItems(
        reservation,
        selectedCreditItemsToCreditData || selectedItems,
        paymentCurrecies,
        selectedCreditData?.hash_currency || {},
        /* currencySelected?.hash_currency !== undefined */
      )
    setIsChangeExchange(false)
  }

  const onCloseCreditModal = () => {
    setSelectedCreditData({})
    setOpenCreditModal(false)
    setSelectedItemsToCreditData([])
  }

  const onCloseMoveCreditReservationModal = () => {
    setMoveCreditReservationForm({})
    setOpenMoveCreditReservationModal(false)
    setReservtions([])
    setShowedChangeType(null)
    setReservationSelectedHasNotBusiness(false)
    setReservationSelected(null)
  }

  const onCloseEditTransactionModal = () => {
    setOpenEditTransactionModal(false)
    setCurrentIndexSelected(null)
    setDefaultValueTransaction({})
    setSelectedRecord({})
  }

  const refoundIsDisable = (transaction) => {
    try {
      const status = transaction?.payment_entity_relation?.status
      const payment_entity = transaction?.payment_entity_relation?.ref_table_detail
      return !(
        (status === CONFIRMED || status === PENDING || status === CREATED) &&
        (payment_entity.toLowerCase() === 'payment_braspag' ||
          payment_entity.toLowerCase() === 'payment_pix' ||
          payment_entity.toLowerCase() === 'payment_online')
      )
    } catch (error) {
      return true // DISABLE BUTTON IF THERE ARE ERROR
    }
  }

  const capturePaymentIsDisable = (transaction) => {
    try {
      const status = transaction?.payment_entity_relation?.status
      const payment_entity = transaction?.payment_entity_relation?.ref_table_detail
      return !((status === PENDING || status === CREATED))
    } catch (error) {
      return true // DISABLE BUTTON IF THERE ARE ERROR
    }
  }

  const paginatedCreditData = selectedCreditItemsToCreditData?.slice(
    paginationCreditModal.page * paginationCreditModal.rowsPerPage,
    paginationCreditModal.page * paginationCreditModal.rowsPerPage + paginationCreditModal.rowsPerPage
  )

  const tooltipContent = (
    <Typography>
      Id de Recibo en Sistema de Facturacion <br />
    </Typography>
  )

  const onChangeReservation = (value) => {
    clearTimeout(timeoutReservtions)
    if (value && searchBy) {
      const timeout = setTimeout(async () => {
        setLoadingReservtions(true)
        let params = {}
        if (isNaN(value)) {
          params[searchBy] = value
        } else {
          params['id'] = value
        }
        try {
          let response = await reservationServices.getOneByParams(params)
          const filter_current_reservation = response.filter(
            (opt) => opt?.number !== reservation?.number || opt?.id !== reservation?.id
          )
          setReservtions(filter_current_reservation)
        } catch (error) {
          setReservtions([])
        } finally {
          setLoadingReservtions(false)
        }
      }, 1000)
      setTimeoutReservtions(timeout)
    } else {
      setReservtions([])
    }
  }

  const handleInput = (event) => {
    if (searchBy === 'id') {
      const value = event.target.value
      // sacar caracteres que no sean números
      const numericValue = value.replace(/[^0-9]/g, '')
      if (value !== numericValue) {
        event.target.value = numericValue
        event.preventDefault()
      }
    }
  }

  const showKeys = (reservation) => {
    let string = ''
    const work_unit_short_name = reservation?.work_unit_short_name
    const business_unit_long_name = reservation?.business_unit_long_name
    const number = reservation?.number
    const date_in = reservation?.date_in

    if (number) {
      string += number
    }
    if (date_in) {
      string += ' | ' + date_in
    }
    if (work_unit_short_name) {
      string += ' | ' + work_unit_short_name
    }

    if (business_unit_long_name) {
      string += ' | ' + business_unit_long_name
    }

    return string
  }

  const checkExistBusinessInReservationSelected = async (reservationSelected) => {
    try {
      if (reservationSelected?.id) {
        const response = await reservationServices.checkSale(reservationSelected?.id)
        if (response && response['System response']?.Exists === 'true') {
          return true
        }
        return false
      }
    } catch (error) {
      return false
    }
  }

  const checkReservationBusinessSelected = async (reservationSelected) => {
    try {
      setReservationSelectedHasNotBusinessLoading(true)
      const response = await checkExistBusinessInReservationSelected(reservationSelected)
      setReservationSelectedHasNotBusiness(!response)
    } catch (error) {
      setReservationSelectedHasNotBusiness(true)
    } finally {
      setReservationSelectedHasNotBusinessLoading(false)
    }
  }

  const applyCredits = async() =>{
    setApplyCreditsLoading(true)
    await paymentServices.applyCredits(reservation.hash_reservation).then(()=>{
      notify('ra.notification.apply_credits_success',{type:'success'})
      setOpenApplyCreditsModal(false)
      getUnusedCredits()
      refetch()
      setRefrshReserveCreditsApplied(applied=>!applied)
    }).catch(()=>{
      notify('ra.notification.apply_credits_error',{type:'error'})
    }).finally(()=>{
      setApplyCreditsLoading(false)
    })
  }

  const onChangeChangeType = (e)=>{
    let formattedValue = e.target.value
    setShowedChangeType(formattedValue)
    let value = formattedValue
    if(formattedValue){
      /* formattedValue = formattedValue?.replaceAll('.','') */
      formattedValue = formattedValue?.replaceAll(',','.')
      value = parseFloat(formattedValue)
    }
    handleChangeMoveCreditReservation('currency_value', value)
  }

  const formatCommas = (text) =>{
    if(text)
      return text.replace(',', '.')
    return null
  }
  const formatDots = (text) =>{
    return text.replace(/\./g, '')
  }

  return (
    <div className='payment_reservation'>
      <ItemBalences 
        reservation={reservation} 
        getPayments={getPayments} 
        getUnusedCredits={getUnusedCredits}
      />

      <ShowCard
        title={translate('ra.title.transactions')}
        preActionButtonJustify='flex-end'
        preActionButton={
          <>
            <LoadingButton loading={loadingRefresh} onClick={getPayments}>
              <RefreshIcon />
            </LoadingButton>
            {dataList.length > 0 && generateReceipt && (
              <Button
                variant='outlined'
                size='small'
                style={{ margin: '0 10px 0 10px' }}
                onClick={handleCancelGeneratesReceipt}
              >
                {translate('ra.action.cancel')}
              </Button>
            )}
            {hasPermissionFunction('voucher', PERMISSION_RECEIPT) && dataList.length > 0 && !importingReceipt && (
              <Button
                variant='contained'
                size='small'
                startIcon={generateReceipt ? <Save /> : null}
                onClick={handleClickGeneratesReceipt}
                style={{ margin: '0 10px 0 10px' }}
                disabled={
                  loadingGenerateReceipt ||
                  dataListLoading ||
                  (generateReceipt && selectedTransactions.length === 0)
                }
              >
                {generateReceipt
                  ? translate('ra.action.to_confirm')
                  : translate('ra.action.generate_receipt')}
              </Button>
            )}
            {dataList.length > 0 && importingReceipt && (
              <Button
                variant='outlined'
                size='small'
                style={{ margin: '0 10px 0 10px' }}
                onClick={handleCancelImportReceipt}
              >
                {translate('ra.action.cancel')}
              </Button>
            )}
            {hasPermissionFunction('voucher', PERMISSION_RECEIPT) && dataList.length > 0 && !generateReceipt && (
              <Button
                variant='contained'
                size='small'
                style={{ margin: '0 10px 0 10px' }}
                startIcon={importingReceipt ? <Save /> : null}
                onClick={handleClickImportReceipt}
                disabled={
                  dataListLoading || (importingReceipt && selectedTransactions.length === 0)
                }
              >
                {importingReceipt ? translate('ra.action.to_confirm') : translate('ra.action.import')}
              </Button>
            )}
          </>
        }
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {(importingReceipt || generateReceipt) && <TableCell />}
                <TableCell />
                <TableCell>{translate('ra.field.id')}</TableCell>
                <TableCell>{translate('ra.field.date')}</TableCell>
                <TableCell>{translate('ra.field.payment_type')}</TableCell>
                <TableCell>{translate('ra.field.currency')}</TableCell>
                <TableCell>{translate('ra.field.amount')}</TableCell>
                <TableCell>{translate('ra.field.change_type')}</TableCell>
                <TableCell>{translate('ra.field.change_type_reversed')}</TableCell>
                {hasPermissionFunction('sales', PERMISSION_LIST) && (
                  <TableCell>{translate('ra.field.receipt_number')}</TableCell>
                )}
                <TableCell>{translate('ra.field.status')}</TableCell>
                {hasPermissionFunction('item', PERMISSION_FRAUD) && (
                  <TableCell>{translate('ra.field.status_fraud')}</TableCell>
                )}
                <TableCell>{translate('ra.action.actions')}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {dataListLoading || loadingTransactionEdit ? (
                <TableRow>
                  {[...Array(importingReceipt || generateReceipt ? 12 : 11)].map((_, i) => (
                    <TableCell key={i}>
                      <Skeleton variant='rectangular' width={'100%'} height={20} />
                    </TableCell>
                  ))}
                </TableRow>
              ) : (
                (paginationData.rowsPerPage > 0
                  ? dataList.slice(
                    paginationData.page * paginationData.rowsPerPage,
                    paginationData.page * paginationData.rowsPerPage + paginationData.rowsPerPage
                  )
                  : dataList
                ).map((row, i) => {
                  const isExpanded = openRows.includes(row.id)
                  const fields = paymentDetailsByType[row?.payment_entity_relation?.ref_table_detail] || []

                  return (
                    <Fragment key={i}>
                      <TableRow>
                        {(importingReceipt || generateReceipt) && (
                          <TableCell style={{ padding: '0px 16px', maxWidth: 30 }}>
                            <Checkbox
                              style={{ padding: 0, width: 18 }}
                              onClick={(e) => handleSelectTransaction(row, e.target.checked)}
                              checked={
                                selectedTransactions?.includes(row?.payment_entity_relation?.id)
                                  ? true
                                  : false
                              }
                              disabled={row?.receipt_number}
                            />
                          </TableCell>
                        )}
                        <TableCell style={{ padding: '0px 16px', maxWidth: 50 }}>
                          {fields.length > 0 ? (
                            <IconButton size='small' onClick={() => onExpandRow(row.id)}>
                              {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>
                          ) : null}
                        </TableCell>
                        <TableCell>{row?.payment_entity_relation?.id}</TableCell>
                        <TableCell>
                          {row?.payment_entity_relation?.payment_detail_relation?.date_time
                            ? new Date(
                              row?.payment_entity_relation?.payment_detail_relation?.date_time
                            ).toLocaleDateString()
                            : ''}
                        </TableCell>
                        <TableCell>{row?.payment_entity_relation?.type}</TableCell>
                        <TableCell>
                          {row?.payment_entity_relation?.payment_detail_relation?.currency}
                        </TableCell>
                        <TableCell>
                          {numberFormatterWithDecimalAndThousand(
                            row?.payment_entity_relation?.payment_detail_relation?.amount
                          )}
                        </TableCell>
                        <TableCell>{row?.currency_value}</TableCell>
                        <TableCell>{row?.currency_value_reversed}</TableCell>
                        {hasPermissionFunction('sales', PERMISSION_LIST) && (
                          <TableCell>{row?.receipt_number ? `#${row.receipt_number}` : ''}</TableCell>
                        )}
                        <StatusTableCell data={row?.payment_entity_relation?.status} />
                        {hasPermissionFunction('item', PERMISSION_FRAUD) && (
                          <StatusTableCell
                            data={
                              row?.payment_entity_relation?.status_fraud
                                ? row?.payment_entity_relation?.status_fraud
                                : '--'
                            }
                          />
                        )}
                        {openEditTransactionModal && currentIndexSelected === i && (
                          <FormWrapper
                            defaultValues={defaultValueTransaction}
                            key={i}
                            open={openEditTransactionModal}
                            handleClose={onCloseEditTransactionModal}
                            selectedWorkUnit={reservation?.work_unit_relation}
                            selectedBusinessUnit={reservation?.business_unit_relation}
                            selectedRecord={selectedRecord}
                            setLoading={setLoadingTransactionEdit}
                            getPayments={getPayments}
                          />
                        )}
                        <TableCell style={{ padding: '0px 16px' }}>
                          <Tooltip placement='top' title='Ver detalle'>
                            <LoadingButton
                              size='small'
                              onClick={() => handleShowTransactionDetail(row?.payment_entity_relation?.id)}
                              disabled={loadingDetail}
                              loading={loadingDetail === row?.payment_entity_relation?.id}
                              startIcon={<Visibility fontSize='small' />}
                              color='primary'
                            ></LoadingButton>
                          </Tooltip>
                          <Tooltip placement='top' title={translate('ra.action.edit')}>
                            <LoadingButton
                              size='small'
                              onClick={() => onOpenEditTransactionModal(row, i)}
                              disabled={null}
                              loading={null}
                              startIcon={<Edit fontSize='small' />}
                              color='primary'
                            ></LoadingButton>
                          </Tooltip>
                          <HasPermission permission={'unapply'} resource={'payment-entity'}>
                            <Tooltip placement='top' title={translate('ra.action.unapply_payment')}>
                              <LoadingButton
                                size='small'
                                onClick={() => { 
                                  setCancelConfirmation(true); 
                                  setIdToCancel(row.payment_entity_id); 
                                  setAmountToUnapply(row.payment_entity_relation?.payment_detail_relation?.amount)
                                  setCurrencyToUanpply(row?.payment_entity_relation?.payment_detail_relation?.currency)
                                }}
                                disabled={row.payment_entity_relation?.status === "CANCELLED" || 
                                  row.payment_entity_relation?.status === "DELETED" ||
                                  row.payment_entity_relation?.status === "CONFIRMED_UNAPPLIED"
                                }
                                loading={null}
                                startIcon={<CreditCardOffIcon fontSize='small' />}
                                color='primary'
                              ></LoadingButton>
                            </Tooltip>
                          </HasPermission>
                          {row?.receipt_number && (
                            <HasPermission permission={PERMISSION_CREATE} resource={'payment-entity'}>
                              <Tooltip placement='top' title={translate('ra.message.cancel_receipt_title')}>
                                <IconButton
                                  size='small'
                                  disabled={loadingReceipt}
                                  onClick={() =>
                                    handleOpenConfirmationModal('cancel_receipt_title', () =>
                                      handleCancelReceipt(row)
                                    )
                                  }
                                >
                                  <Clear fontSize='small' />
                                </IconButton>
                              </Tooltip>
                            </HasPermission>
                          )}
                          {row?.payment_entity_relation?.payment_detail_relation?.status !== 'DELETED' && (
                            <>
                              {!row?.receipt_number && (
                                <HasPermission permission={PERMISSION_RECEIPT} resource={'voucher'}>
                                  <Tooltip
                                    placement='top'
                                    title={translate('ra.message.generate_receipt_title')}
                                  >
                                    <LoadingButton
                                      size='small'
                                      onClick={() =>
                                        handleOpenConfirmationModal('generate_receipt_title', () =>
                                          handleGenerateReceipt(row)
                                        )
                                      }
                                      disabled={loadingReceipt}
                                      loading={loadingReceipt === row?.payment_entity_relation?.id}
                                      startIcon={<Inventory2Outlined fontSize='small' />}
                                      color='primary'
                                    ></LoadingButton>
                                  </Tooltip>
                                </HasPermission>
                              )}

                              <HasPermission permission={PERMISSION_REFOUND} resource={'payment-entity'}>
                                <Tooltip
                                  placement='top'
                                  title={translate('ra.message.refund_transaction_title')}
                                >
                                  <LoadingButton
                                    size='small'
                                    onClick={() =>
                                      handleOpenConfirmationModal('refund_transaction_title', () =>
                                        handleRefoundTransaction(row)
                                      )
                                    }
                                    disabled={refoundIsDisable(row)}
                                    loading={loadingRefund === row?.payment_entity_relation?.id}
                                    startIcon={<MoneyOffIcon fontSize='small' />}
                                    color='primary'
                                  ></LoadingButton>
                                </Tooltip>
                              </HasPermission>

                              <HasPermission permission={PERMISSION_CAPTURE} resource={'payment-entity'}>
                                <Tooltip
                                  placement='top'
                                  title={translate('ra.message.capture_payment_title')}
                                >
                                  <LoadingButton
                                    size='small'
                                    onClick={() =>
                                      handleOpenConfirmationModal('capture_payment_title', () =>
                                        handleCapturePaymentTransaction(row)
                                      )
                                    }
                                    disabled={capturePaymentIsDisable(row)}
                                    loading={loadingCapturePayment === row?.payment_entity_relation?.id}
                                    startIcon={<CreditScoreIcon fontSize='small' />}
                                    color='primary'
                                  ></LoadingButton>
                                </Tooltip>
                              </HasPermission>

                              <HasPermission permission={PERMISSION_DELETE} resource={'payment-entity'}>
                                <Tooltip
                                  placement='top'
                                  title={translate('ra.message.delete_transaction_title')}
                                >
                                  <IconButton
                                    size='small'
                                    color='error'
                                    onClick={() =>
                                      handleOpenConfirmationModal('delete_transaction_title', () =>
                                        handleDeleteTransaction(row)
                                      )
                                    }
                                  >
                                    <Delete fontSize='small' />
                                  </IconButton>
                                </Tooltip>
                              </HasPermission>
                            </>
                          )}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell className='collapsible-row' colSpan={12}>
                          <Collapse in={isExpanded} unmountOnExit>
                            {fields.map((field, j) => {
                              if (field === 'vendor_code') {
                                return (
                                  <div key={j} style={{ display: 'flex', flexDirection: 'column' }} className='field'>
                                    <b>{row?.payment_entity_relation?.type}</b>
                                    <span>{row?.payment_entity_relation?.payment_detail_relation?.[field]}</span>
                                  </div>
                                )
                              }
                              return getField(
                                j,
                                row?.payment_entity_relation?.payment_detail_relation,
                                field,
                                translate
                              )
                            })}
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </Fragment>
                  )
                })
              )}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  count={dataList.length}
                  rowsPerPage={paginationData.rowsPerPage}
                  page={paginationData.page}
                  onPageChange={(e, number) => onPageChange(number)}
                  onRowsPerPageChange={(e) => onRowsPerPageChange(e)}
                  labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}–${to} ${translate('ra.navigation.of')} ${count}`
                  }
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </ShowCard>

      <Grid container spacing={1}>
        <Grid item xs={12} md={12} lg={5} xl={4}>
          <ShowCard
            title={translate('ra.title.reservation_credit')}
            preActionButtonJustify='flex-end'
            preActionButton={
              <>
                <HasPermission permission={PERMISSION_CREATE} resource={'payment-entity'}>
                  <LoadingButton disabled={unusedCredits?.length === 0} loading={applyCreditsLoading} onClick={()=>setOpenApplyCreditsModal(true)}>
                    <Tooltip placement='top' title={translate('ra.action.apply_credits')}>
                      <CreditScoreIcon />
                    </Tooltip>
                  </LoadingButton>
                </HasPermission>
                <LoadingButton loading={unusedCreditsLoading} onClick={getUnusedCredits}>
                  <RefreshIcon />
                </LoadingButton>
              </>
            }
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>{translate('ra.field.currency')}</TableCell>
                    <TableCell>{translate('ra.field.amount_unused')}</TableCell>
                    <TableCell>{translate('ra.action.actions')}</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {unusedCreditsLoading ? (
                    <TableRow>
                      {[...Array(3)].map((_, i) => (
                        <TableCell key={i}>
                          <Skeleton variant='rectangular' width={'100%'} height={20} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ) : (
                    (paginationCreditData.rowsPerPage > 0
                      ? unusedCredits?.slice(
                        paginationCreditData.page * paginationCreditData.rowsPerPage,
                        paginationCreditData.page * paginationCreditData.rowsPerPage +
                        paginationCreditData.rowsPerPage
                      )
                      : unusedCredits
                    )?.map((row, i) => {
                      return (
                        <Fragment key={i}>
                          <TableRow>
                            <TableCell style={{ padding: '0px 16px', maxWidth: 50 }}>
                              {row.individual?.length > 0 ? (
                                  <ShowUnusedCreditsInfo setUnusedCreditsExpandInfo = {setUnusedCreditsExpandInfo} unusedCreditsExpandInfo={unusedCreditsExpandInfo} index={i}/>
                              ) : null}
                            </TableCell>
                            <TableCell>{row?.currency_unused}</TableCell>
                            <TableCell>{numberFormatterWithDecimalAndThousand(row?.amount_unused)}</TableCell>

                            <TableCell>
                              <div style={{display:'flex', flexDirection:'row'}}>
                              <HasPermission permission={PERMISSION_CREATE} resource={'payment-entity'}>
                                <Button
                                  variant='outlined'
                                  size='small'
                                  onClick={async () => await handleOpenCreditModal(row)}
                                  sx={{ marginRight: '5px' }}
                                >
                                  {translate('ra.action.pay')}
                                </Button>
                              </HasPermission>
                              <HasPermission permission={PERMISSION_MOVE_CREDIT} resource={'item'}>
                                {/* <Tooltip
                                  title={
                                    reservationHasNotBusiness
                                      ? translate('ra.message.reservation_from_without_business')
                                      : ''
                                  }
                                  disableHoverListener={reservationHasNotBusiness}
                                > */}
                                  <span>
                                    <Button
                                      variant='outlined'
                                      size='small'
                                      sx={{ marginRight: '5px' }}
                                      /* disabled={reservationHasNotBusiness || reservationHasNotBusinessLoading} */
                                      onClick={async () => await handleOpenMoveCreditReservationModal(row)}
                                    >
                                      {translate('ra.action.move')}
                                    </Button>
                                  </span>
                                {/* </Tooltip> */}
                              </HasPermission>
                              <HasPermission permission={PERMISSION_CREATE} resource={'reimbursement'}>
                                {/* <Tooltip
                                  title={
                                    reservationHasNotBusiness
                                      ? translate('ra.message.reservation_from_without_business')
                                      : ''
                                  }
                                  disableHoverListener={reservationHasNotBusiness}
                                > */}
                                  <span>
                                    <Button
                                      variant='outlined'
                                      size='small'
                                      disabled = {!row?.currency_unused || row?.currency_unused === 0}
                                      onClick={() => {setOpenReturnDialog(true); setRowToReturn(row)}}
                                    >
                                      {translate('ra.action.return')}
                                    </Button>
                                  </span>
                                {/* </Tooltip> */}
                              </HasPermission>
                              </div>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className='collapsible-row' colSpan={12}>
                              <Collapse in={unusedCreditsExpandInfo[i]} unmountOnExit>
                              <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
                              {row.individual?.map((field, j) => {
                                return(
                                  <div style={{display:'flex',marginTop:'15px', flexDirection:'row', justifyContent:'space-evenly', width:'100%'}}>
                                    <div style={{display:'flex', flexDirection:'column', marginRight:'15px'}}>
                                      <b>{'ID'}</b>
                                      <span>{field.id}</span>
                                    </div>
                                    <div style={{display:'flex', flexDirection:'column', marginRight:'15px'}}>
                                      <b>{translate('ra.field.date')}</b>
                                      <span>{parseDateFormat(field.created_at)}</span>
                                    </div>
                                    <div style={{display:'flex', flexDirection:'column', marginRight:'15px'}}>
                                      <b>{translate('ra.field.amount_pending')}</b>
                                      <span>{numberFormatterWithDecimalAndThousand(field.amount_pending)}</span>
                                    </div>
                                    <div style={{display:'flex', flexDirection:'row', marginRight:'15px'}}>
                                      <LoadingButton
                                        size='small'
                                        onClick={() => {setCreditsDetailId(field.id); setOpenCreditsDetail(true)}}
                                        /* disabled={loadingDetail}
                                        loading={loadingDetail === row?.payment_entity_relation?.id} */
                                        startIcon={<Visibility fontSize='small' />}
                                        color='primary'
                                      ></LoadingButton>
                                      <LoadingButton
                                        size='small'
                                        onClick={() => {
                                          const foundCredit = unusedCredits?.find(credit=>credit.ids.includes(field.id)) ?? []
                                          const founIndividual = foundCredit?.individual.find(individual=>individual.id === field.id) ?? {}
                                          setCreditToEdit(founIndividual); 
                                          setOpenCreditsEdit(true)
                                          setCreditsDetailId(field.id)
                                        }}
                                        startIcon={<EditIcon fontSize='small' />}
                                        color='primary'
                                      ></LoadingButton>

                                    </div>
                                  </div>
                                )
                              })}
                              </div>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </Fragment>
                      )
                    })
                  )}
                </TableBody>

                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      colSpan={12}
                      count={unusedCredits?.length}
                      rowsPerPage={paginationCreditData.rowsPerPage}
                      page={paginationCreditData.page}
                      onPageChange={(e, number) => onPageCreditChange(number)}
                      onRowsPerPageChange={(e) => onRowsPerPageCreditChange(e)}
                      labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}–${to} ${translate('ra.navigation.of')} ${count}`
                      }
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </ShowCard>
        </Grid>
        <HasPermission permission={'get'} resource={'reimbursement'}>
        <Grid item xs={12} md={12} lg={7} xl={8}>
            <ReturnsTable hash_reservation={reservation.hash_reservation} />
        </Grid>
      </HasPermission>
      </Grid>
      <HasPermission permission={'show'} resource={'account-transfer'}>
        <BalanceTransfer hash_reservation={reservation.hash_reservation} currentNumber={reservation.number}/>
      </HasPermission>
      <ReserveCreditsApplied originNumber={reservation.number} dataList={dataListCreditUsed} dataListLoading={dataListCreditUsedLoading} setRefrshReserveCreditsApplied={setRefrshReserveCreditsApplied} refreshReserveCreditsApplied={refreshReserveCreditsApplied} />
      <Confirm
        isOpen={openConfirmationModal}
        title={`ra.message.${modalData?.title}`}
        content='ra.message.confirm_action_content'
        loading={loadingReceipt || loadingRefund || loadingCapturePayment || loadingGenerateReceipt}
        onConfirm={() => (modalData?.callback ? modalData.callback() : null)}
        onClose={() => setOpenConfirmationModal(false)}
      />
      <Confirm
        isOpen={openApplyCreditsModal}
        title={`ra.action.apply_credits`}
        content='ra.message.confirmation_apply_credits'
        loading={applyCreditsLoading}
        onConfirm={applyCredits}
        onClose={() => setOpenApplyCreditsModal(false)}
      />

      <Dialog fullWidth maxWidth='sm' open={openReceiptModal} onClose={() => setOpenReceiptModal(false)}>
        <DialogTitle>{translate('ra.message.import_receipt_title')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <EditInputsWrap
              label={translate('ra.field.receipt_reference')}
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
              tooltiptext={tooltipContent}
            >
              <TextField
                value={receiptForm?.receipt_reference || ''}
                onChange={(e) => handleChangeReceiptData('receipt_reference', e.target.value)}
                label={'123456'}
                size='small'
                sx={{
                  width: { xs: '100%', sm: '50%' },
                  '& legend': { display: 'none' },
                  '& .MuiInputLabel-shrink': { opacity: 0, transition: 'all 0.2s ease-in' },
                }}
              />
            </EditInputsWrap>

            {/* <EditInputsWrap
              label={'CAE'}
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={receiptForm?.CAE || ''}
                onChange={(e) => handleChangeReceiptData('CAE', e.target.value)}
                label={'CAE'}
                size='small'
                sx={{
                  width: { xs: '100%', sm: '50%' },
                  '& legend': { display: 'none' },
                  '& .MuiInputLabel-shrink': { opacity: 0, transition: 'all 0.2s ease-in' },
                }}
              />
            </EditInputsWrap> */}

            {/* <EditInputsWrap
              label={`${translate('ra.field.differentiated_change_type')} (${translate(
                'ra.message.optional'
              )})`}
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={receiptForm?.currency_value || ''}
                onChange={(e) => handleChangeReceiptData('currency_value', e.target.value)}
                size='small'
                type='number'
                sx={{ width: { xs: '100%', sm: '50%' } }}
              />
            </EditInputsWrap> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setOpenReceiptModal(false)}>
            {translate('ra.action.cancel')}
          </Button>
          <LoadingButton
            loading={dataListLoading}
            size='small'
            variant='contained'
            disabled={importingReceipt && (!receiptForm?.receipt_reference && !receiptForm?.CAE)}
            onClick={() => handleOpenConfirmationModal('import_receipt_title', handleImportReceipt)}
          >
            {translate('ra.action.continue')}
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <Dialog fullWidth maxWidth='md' open={openDetailModal} onClose={() => setOpenDetailModal(false)}>
        <DialogTitle>{translate('ra.message.transaction_detail_title')}</DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{translate('ra.field.reserve')}</TableCell>
                  <TableCell>{translate('ra.field.currency')}</TableCell>
                  <TableCell>{translate('ra.field.amount')}</TableCell>
                  <TableCell>{translate('ra.field.change_type')}</TableCell>
                  <TableCell>{translate('ra.field.change_type_reversed')}</TableCell>
                  {detailModalData.some((elem) => elem?.description || elem?.detail_code) && (
                    <>
                      <TableCell>{translate('ra.field.description')}</TableCell>
                      <TableCell>{translate('ra.field.locator')}</TableCell>
                    </>
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {detailModalData.map((elem, i) => (
                  <TableRow key={i}>
                    <TableCell>{elem?.reservation?.number}</TableCell>
                    <TableCell>{elem?.currency}</TableCell>
                    <TableCell>{elem?.amount}</TableCell>
                    <TableCell>{elem?.currency_value}</TableCell>
                    <TableCell>{elem?.currency_value_reversed}</TableCell>
                    {detailModalData.some((elem) => elem?.description || elem?.detail_code) && (
                      <>
                        <TableCell>{elem?.description}</TableCell>
                        <TableCell>{elem?.detail_code}</TableCell>
                      </>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setOpenDetailModal(false)}>
            {translate('ra.action.close')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog fullWidth maxWidth='md' open={openCreditModal} onClose={onCloseCreditModal}>
        <DialogTitle>{translate('ra.title.compensation_credit')}</DialogTitle>
        <Grid container item>
          <Grid item md={4} lg={4}>
            {paymentCurrecies.length > 0 && (
              <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <Box className='currency_resume'>
                  {loadingPaymentCurrencies
                    ? Array.from(new Array(3)).map((_, i) => (
                      <Box key={i} mb={2} display={'flex'}>
                        <Skeleton variant='text' width={30} height={10} /> -
                        <Skeleton variant='text' width={30} height={10} />:
                        <Skeleton variant='text' width={30} height={10} />
                      </Box>
                    ))
                    : paymentCurrecies.map((currency, i) => (
                      <Box key={i}>
                        <Typography component='span' fontWeight='bold'>
                          {currency?.currency_relation?.short_name}-
                          {currency?.currency_to_relation?.short_name} : {currency.value}
                        </Typography>
                      </Box>
                    ))}
                </Box>
                {hasPermissionFunction('currency-by-work-unit', PERMISSION_EDIT) && (
                  <Box display={'flex'}>
                    <Button onClick={() => setOpenExchangeModal(true)}>
                      <EditIcon />
                    </Button>
                  </Box>
                )}
              </Box>
            )}
          </Grid>
          <Grid item md={8} lg={8}>
            <Box>
              <Typography variant='h6' component='h6'>
                {translate('ra.field.total')} {selectedCreditData?.currency_unused} :{' '}
                {numberFormatterWithDecimalAndThousand(selectedCreditData?.amount_unused)}
              </Typography>
              <Typography
                variant='h6'
                component='h6'
                style={{ color: remainingAmount < 0 ? 'red' : 'inherit' }}
              >
                {translate('ra.field.amount_to_apply')} {selectedCreditData?.currency_unused} :{' '}
                {numberFormatterWithDecimalAndThousand(remainingAmount)}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <DialogContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{translate('ra.field.item_descripcion')}</TableCell>
                  <TableCell>{translate('ra.field.locator')}</TableCell>
                  <TableCell>{translate('ra.field.currency')}</TableCell>
                  <TableCell>{translate('ra.field.amount_pending')}</TableCell>
                  <TableCell>
                    {translate('ra.field.amount_pending_in', {
                      currency: selectedCreditData?.currency_unused,
                    })}
                  </TableCell>
                  <TableCell>
                    {translate('ra.field.amount_compensated', {
                      currency: selectedCreditData?.currency_unused,
                    })}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {dataListLoading || loadingItemRecalculate ? (
                  <TableRow>
                    {[...Array(5)].map((_, i) => (
                      <TableCell key={i}>
                        <Skeleton variant='rectangular' width={'100%'} height={20} />
                      </TableCell>
                    ))}
                  </TableRow>
                ) : (
                  <>
                    {paginatedCreditData.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell>{getProductName(row)}</TableCell>
                        <TableCell>{row?.code}</TableCell>
                        <TableCell>{row?.currency}</TableCell>
                        <TableCell>{numberFormatterWithDecimalAndThousand(row?.amount_pending)}</TableCell>
                        <TableCell>
                          {loadingItemRecalculate ? (
                            <>
                              <Skeleton variant='rectangular' width={60} height={20} />
                            </>
                          ) : (
                            numberFormatterWithDecimalAndThousand(row?.amount_pending_converted)
                          )}
                        </TableCell>
                        <TableCell>
                          <TextField
                            type='number'
                            value={row?.amount_to_pay || 0}
                            onChange={(e) => handleCreditAmountChange(e, i)}
                            size='small'
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                )}
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[2, 5, 10, 25, 50]}
                    count={selectedCreditItemsToCreditData.length}
                    rowsPerPage={paginationCreditModal.rowsPerPage}
                    page={paginationCreditModal.page}
                    onPageChange={handlePageChangeCreditModal}
                    onRowsPerPageChange={handleRowsPerPageChangeCreditModal}
                    labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}–${to} ${translate('ra.navigation.of')} ${count}`
                    }
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={onCloseCreditModal}>
            {translate('ra.action.cancel')}
          </Button>
          <LoadingButton
            loading={loadingDetail || loadingCreditConfirm}
            size='small'
            variant='contained'
            onClick={onConfirmCreditModal}
            disabled={remainingAmount < 0 || remainingAmount === selectedCreditData?.amount_unused}
          >
            {translate('ra.action.confirm')}
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth='md'
        open={openMoveCreditReservationModal}
        onClose={onCloseMoveCreditReservationModal}
      >
        <DialogTitle>{translate('ra.title.move_credit_reservation')}</DialogTitle>
        <DialogContent>
          <Grid container item marginTop={'10px'}>
            <EditInputsWrap md={3} lg={3} label={translate('ra.field.search_by')}>
              <Autocomplete
                size='small'
                options={[
                  {
                    id: 'number__ilike',
                    name: translate('ra.field.number'),
                  },
                  {
                    id: 'id',
                    name: translate('ra.field.id'),
                  },
                ]}
                renderInput={(params) => <TextField {...params} label='' />}
                getOptionLabel={(option) => option.name}
                noOptionsText={translate('ra.validation.noOptionsText')}
                placeholder={translate('ra.field.search_by')}
                defaultValue={{
                  id: 'number__ilike',
                  name: translate('ra.field.number'),
                }}
                onChange={(e, value) => {
                  setSearchBy(value?.id)
                  setReservtions([])
                }}
              />
            </EditInputsWrap>
            <EditInputsWrap md={9} lg={9} className='input-gray'>
              <Autocomplete
                size='small'
                options={reservations || []}
                getOptionLabel={(option) => showKeys(option)}
                loading={loadingReservtions}
                loadingText={translate('ra.action.loading')}
                filterOptions={() => reservations}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={translate('ra.field.search_reservation')}
                    onChange={(e) => onChangeReservation(e.target.value)}
                    onInput={handleInput}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: <Search />,
                      endAdornment: (
                        <>
                          {loadingReservtions ? <CircularProgress color='inherit' size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                onChange={async (e, value) => {
                  setReservationSelected(value)
                  checkReservationBusinessSelected(value)
                }}
                noOptionsText={translate('ra.validation.noOptionsText')}
                placeholder={translate('ra.field.search_client')}
                disabled={!searchBy}
              />
            </EditInputsWrap>
          </Grid>
          {/* <Box display={'flex'} justifyContent={'flex-end'} marginBottom={'10px'}>
            {reservationSelected ? (
              reservationSelectedHasNotBusiness ? (
                <Alert sx={{ width: '80%' }} severity='warning'>
                  {translate('ra.message.reservation_to_without_business')}
                </Alert>
              ) : null
            ) : null}
          </Box> */}
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.date')} md={4} lg={4} style={{ minHeight: 0 }}>
              <TextField
                value={moveCreditReservationForm?.date || ''}
                onChange={(e) => handleChangeMoveCreditReservation('date', e.target.value)}
                size='small'
                type='date'
                sx={{
                  width: { xs: '100%', sm: '100%' },
                  '& legend': { display: 'none' },
                  '& .MuiInputLabel-shrink': { opacity: 0, transition: 'all 0.2s ease-in' },
                }}
              />
            </EditInputsWrap>

            {/* <EditInputsWrap
              label={`${translate('ra.field.differentiated_change_type')} (${translate(
                'ra.message.optional'
              )})`}
              md={4}
              lg={4}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={moveCreditReservationForm?.currency_value || ''}
                onChange={(e) => handleChangeMoveCreditReservation('currency_value', e.target.value)}
                size='small'
                type='number'
                sx={{ width: { xs: '100%', sm: '100%' } }}
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={`${translate('ra.field.differentiated_change_type')} (${translate(
                'ra.message.optional'
              )})`}
              md={4}
              lg={4}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={moveCreditReservationForm?.currency_value || ''}
                onChange={(e) => handleChangeMoveCreditReservation('currency_value', e.target.value)}
                size='small'
                type='number'
                sx={{ width: { xs: '100%', sm: '100%' } }}
              />
            </EditInputsWrap> */}
            <EditInputsWrap
              label={`${translate('ra.field.client_code')}  (${translate('ra.message.optional')})`}
              md={4}
              lg={4}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={moveCreditReservationForm?.entity_code || ''}
                onChange={(e) => handleChangeMoveCreditReservation('entity_code', e.target.value)}
                size='small'
                sx={{
                  width: { xs: '100%', sm: '100%' },
                  '& legend': { display: 'none' },
                  '& .MuiInputLabel-shrink': { opacity: 0, transition: 'all 0.2s ease-in' },
                }}
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={`${translate('ra.field.description')} (${translate('ra.message.optional')})`}
              md={8}
              lg={8}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={moveCreditReservationForm?.description || ''}
                onChange={(e) => handleChangeMoveCreditReservation('description', e.target.value)}
                type='text'
                size='small'
                sx={{
                  width: { xs: '100%', sm: '100%' },
                  '& legend': { display: 'none' },
                  '& .MuiInputLabel-shrink': { opacity: 0, transition: 'all 0.2s ease-in' },
                }}
              />
            </EditInputsWrap>
            <EditInputsWrap label={`${translate('ra.field.change_type')} (${translate('ra.message.optional')})`} md={4} lg={4} style={{ minHeight: 0 }}>
              <TextField
                value={showedChangeType}
                onChange={onChangeChangeType}
                onFocus={(e)=>setShowedChangeType(formatDots(e.target.value))}
                onBlur={(e)=>setShowedChangeType(e.target.value ? numberFormatterWithDecimalAndThousand(formatCommas(e.target.value)): null)}
                size='small'
                type='text'
                sx={{ width: { xs: '100%', sm: '100%' } }}
              />
            </EditInputsWrap>
            <MoveCreditReservation
              translate={translate}
              moveCreditReservationForm={moveCreditReservationForm}
              handleChangeMoveCreditReservation={handleChangeMoveCreditReservation}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={onCloseMoveCreditReservationModal}>
            {translate('ra.action.cancel')}
          </Button>
          <LoadingButton
            loading={loadingMoveCreditReservation || reservationSelectedHasNotBusinessLoading}
            size='small'
            variant='contained'
            onClick={tranferCreditReservation}
            disabled={
              !reservationSelected ||
              /* reservationSelectedHasNotBusiness || */
              !moveCreditReservationForm?.amount ||
              reservationSelectedHasNotBusinessLoading ||
              moveCreditReservationForm?.amount > moveCreditReservationForm?.amount_unused
            }
          >
            {translate('ra.action.confirm')}
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <Dialog fullWidth open={openExchangeModal} onClose={onCloseExhangeModal}>
        <DialogTitle>{translate('ra.entity.payment-entity')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            {paymentCurrecies.map((currency, i) => (
              <Grid item xs={12} key={i}>
                <Box display='flex' alignItems='center'>
                  <Typography component='span' fontWeight='bold'>
                    {currency?.currency_relation?.short_name}-{currency?.currency_to_relation?.short_name} :
                  </Typography>
                  <TextField
                    defaultValue={currency.value}
                    onChange={(e) => handleCurrencyChange(i, 'value', e.target.value)}
                    size='small'
                    type='number'
                    sx={{ ml: 2, width: '140px' }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={onCloseExhangeModal}>
            {translate('ra.action.close')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog fullWidth open={openReturnDialog} onClose={() => { setOpenReturnDialog(false) }}>
        <DialogTitle>{translate('ra.action.register_return')}</DialogTitle>
        <DialogContent>
          <ReturnForm record={rowToReturn} hash_reservation={reservation.hash_reservation} setOpenReturnDialog={setOpenReturnDialog} />
        </DialogContent>
      </Dialog>
      <Dialog fullWidth open={openCreditsDetail} onClose={() => { setOpenCreditsDetail(false) }}>
        <DialogTitle>{translate('ra.title.paymentDetails')}</DialogTitle>
        <DialogContent>
          <CreditsDetail account_id={creditsDetailId}/>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={()=>{setOpenCreditsDetail(false)}}>
            {translate('ra.action.close')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog fullWidth open={openCreditsEdit} onClose={() => { setOpenCreditsEdit(false) }}>
        <DialogTitle>{translate('ra.title.credits_data')}</DialogTitle>
        <DialogContent>
          <EditCreditModal updateCredits={getUnusedCredits} id={creditsDetailId} onClose={()=>setOpenCreditsEdit(false)} creditData={creditToEdit}/>
        </DialogContent>
      </Dialog>
      <Dialog fullWidth open={cancelConfirmation} onClose={() => { setCancelConfirmation(false) }}>
        <DialogTitle>{translate('ra.action.unapply_payment') + ` ${idToCancel}`}</DialogTitle>
        <DialogContent>
          {translate('ra.message.unapply_confirmation',{currency:currencyToUnapply, amount:amountToUnapply})}
        </DialogContent>
        <DialogActions style={{justifyContent:'space-between'}}>
          <Button variant='outlined' color='error' onClick={()=>{setCancelConfirmation(false)}}>
            {translate('ra.action.close')}
          </Button>
          <LoadingButton size='small' variant='contained' loading={unapplyLoading} onClick={()=>{setConfirmUnapply(true)}}>
            {translate('ra.action.to_confirm')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}
